import * as CompanyTypes from "../types/company.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";

export const loadCompanies = (filter: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: CompanyTypes.LOADING_COMPANY });

  axiosInstance
    .get("/facility/", { params: { ...filter } })
    .then((res) => {
      dispatch({
        type: CompanyTypes.LOAD_COMPANY,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.message) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.message,
        });
        dispatch(alertActions.error(err.message));
      } else if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const trashCompany = (id: any, filterData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/facility/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(alertActions.success("Delete Success"));
      dispatch(loadCompanies(filterData));
    })
    .catch((err) => {
      dispatch(alertActions.showError(err, "Error deleting data"));
    });
};

export const blukTrashCompany =
  (id: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    axiosInstance
      .delete("/facility/", id)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Delete Success"));

        dispatch(loadCompanies(filterData));
      })
      .catch((err) => {
        dispatch(alertActions.showError(err, "Error deleting data"));
      });
  };

export const saveCompany =
  (userData: any, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CompanyTypes.COMPANY_SAVE_REQUEST });

    axiosInstance
      .post("facility/", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(alertActions.success("Facilty Created Successfully"));
        dispatch({ type: CompanyTypes.COMPANY_SAVE_SUCCESS });
        dispatch(loadCompanies(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const getCompany = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: CompanyTypes.FETCH_COMPANY_REQUEST });

  axiosInstance
    .get("facility/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: CompanyTypes.FETCH_COMPANY_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const updateCompany =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CompanyTypes.COMPANY_SAVE_REQUEST });

    axiosInstance
      .put("facility/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: CompanyTypes.COMPANY_SAVE_SUCCESS });
        dispatch(alertActions.success("Facilty Updated Successfully"));
        dispatch(loadCompanies(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };

export const searchCompanies = (filter: string) => {
  let result = axiosInstance
    .get("/facility/?q=" + filter)
    .then((res) => {
      return res.data.results;
    })
    .catch((err) => {
      return err;
    });

  return result;
};

export const updateCompanyStatus =
  (userData: any, id: number, filterData: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: CompanyTypes.COMPANY_SAVE_REQUEST });

    axiosInstance
      .put("facility/status/" + id, userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch({ type: CompanyTypes.COMPANY_SAVE_SUCCESS });
        dispatch(alertActions.success("Facilty Updated Successfully"));
        dispatch(loadCompanies(filterData));
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.detail.toString()));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.detail.toString(),
          });
        }
      });
  };
